import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-repurchase',
  templateUrl: './home-repurchase.component.html',
  styleUrls: ['./home-repurchase.component.css']
})
export class HomeRepurchaseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/repurchase/components/home-repurchase/home-repurchase.component.ts